// @ts-nocheck
import * as Types from '../../@types/apiql.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TSubmitAdyenCheckoutPaymentDetailsMutationVariables = Types.Exact<{
  input: Types.TSubmitAdyenCheckoutPaymentDetailsInput;
}>;


export type TSubmitAdyenCheckoutPaymentDetailsMutation = { __typename?: 'Mutation', result?: { __typename?: 'SubmitAdyenCheckoutPaymentDetailsPayload', adyenResponse: string } | null };


export const SubmitAdyenCheckoutPaymentDetailsDocument = gql`
    mutation submitAdyenCheckoutPaymentDetails($input: SubmitAdyenCheckoutPaymentDetailsInput!) {
  result: submitAdyenCheckoutPaymentDetails(input: $input) {
    adyenResponse
  }
}
    `;
export type TSubmitAdyenCheckoutPaymentDetailsMutationFn = Apollo.MutationFunction<TSubmitAdyenCheckoutPaymentDetailsMutation, TSubmitAdyenCheckoutPaymentDetailsMutationVariables>;

/**
 * __useSubmitAdyenCheckoutPaymentDetailsMutation__
 *
 * To run a mutation, you first call `useSubmitAdyenCheckoutPaymentDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAdyenCheckoutPaymentDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAdyenCheckoutPaymentDetailsMutation, { data, loading, error }] = useSubmitAdyenCheckoutPaymentDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitAdyenCheckoutPaymentDetailsMutation(baseOptions?: Apollo.MutationHookOptions<TSubmitAdyenCheckoutPaymentDetailsMutation, TSubmitAdyenCheckoutPaymentDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TSubmitAdyenCheckoutPaymentDetailsMutation, TSubmitAdyenCheckoutPaymentDetailsMutationVariables>(SubmitAdyenCheckoutPaymentDetailsDocument, options);
      }
export type SubmitAdyenCheckoutPaymentDetailsMutationHookResult = ReturnType<typeof useSubmitAdyenCheckoutPaymentDetailsMutation>;
export type SubmitAdyenCheckoutPaymentDetailsMutationResult = Apollo.MutationResult<TSubmitAdyenCheckoutPaymentDetailsMutation>;
export type SubmitAdyenCheckoutPaymentDetailsMutationOptions = Apollo.BaseMutationOptions<TSubmitAdyenCheckoutPaymentDetailsMutation, TSubmitAdyenCheckoutPaymentDetailsMutationVariables>;